import { render, staticRenderFns } from "./SystemDisk.vue?vue&type=template&id=0b4f8363"
import script from "./SystemDisk.vue?vue&type=script&lang=js"
export * from "./SystemDisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports